import {Loader} from 'apstra-ui-common';
import React from 'react';

import {ErrorBoundary} from './ErrorBoundary';

type SuspenseWrapperProps = React.PropsWithChildren<{
  fallback?: React.SuspenseProps['fallback']
}>

export const SuspenseWrapper: React.FC<SuspenseWrapperProps> = ({
  children,
  fallback
}) => (
  <ErrorBoundary>
    <React.Suspense fallback={fallback ?? <Loader />} >
      {children}
    </React.Suspense>
  </ErrorBoundary>
);

export const withSuspenseWrapper = <T extends object, >(Component: React.FC<T>): React.FC<T> => (props: T) => {
  return (
    <SuspenseWrapper>
      <Component {...props} />
    </SuspenseWrapper>
  );
};
